import { http } from '@uhg-abyss/web/tools/http';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';

const getSubmitTINRequestApiPath = (isAPIMarketplaceFlow, payload) => {
  const { currentFlow, isDental } = payload;
  let path = currentFlow;

  if (isAPIMarketplaceFlow && isDental) {
    return `/ext/dental/submit/v1`;
  }
  if (currentFlow.includes('provider')) path = 'provider';
  else if (currentFlow.includes('billing')) path = 'billing';
  else if (currentFlow.includes('vendor')) path = 'vendor';
  return isAPIMarketplaceFlow ? `/ext/${path}/submit/v1` : `/${path}/submit/v1`;
};

export const submitTINRequest = async payload => {
  const isAPIMarketplaceFlow = payload.currentFlow.includes('API marketplace');
  const sourceSystem = isAPIMarketplaceFlow ? { sourceSystem: 'apim' } : {};
  const apiPath = getSubmitTINRequestApiPath(isAPIMarketplaceFlow, payload);

  const { currentFlow, isDental, ...apiPayload } = payload;
  const response = await http({
    method: 'POST',
    cache: false,
    headers: { ...sourceSystem },
    withCredentials: true,
    url: `${payload.url}${apiPath}`,
    handleError: async err => {
      const { error } = err.data;
      const { duration, endpoint, message, data, status } = err;
      const errorData = {
        status: data?.error?.code,
        message: data?.error?.description || message,
        code: status,
        duration,
        endpoint,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
      const errObj = {
        error: { ...error, status: err.status },
      };
      return {
        data: {
          ...errObj,
        },
      };
    },
    body: apiPayload,
  });

  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};
